import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const JOB_BASE = process.env.REACT_APP_JOB_CREATE_BASE || "";

export const getCompanyJobs = createAsyncThunk(
  "getCompanyJobs",
  async (pageData: any) => {
    try {
      let url = `${GATEWAY_BASE + JOB_BASE}/api/v1/firm/jobs?skip=${pageData.skip}&limit=${pageData.limit}&firm=${pageData.firm}`;

      if (pageData.q && pageData.q !== "") {
        url += `&q=${encodeURIComponent(pageData.q)}`;
      }
      if (pageData.userId) {
        url += `&userid=${pageData.userId}`;
      }

      if (pageData.filters) {
        const { industries, jobTypes, experiences, locations } = pageData.filters;

        if (industries?.length) {
          url += `&industries=${industries.map(encodeURIComponent).join(",")}`;
        }
        if (jobTypes?.length) {
          url += `&jobTypes=${jobTypes.map(encodeURIComponent).join(",")}`;
        }
        if (experiences?.length) {
          url += `&experiences=${experiences.map(encodeURIComponent).join(",")}`;
        }
        if (locations?.length) {
          url += `&locations=${locations.map(encodeURIComponent).join(",")}`;
        }
      }

      const { data } = await axios.get(url);
      return data;
    } catch (error: any) {
      throw error.response?.data.statusCode;
    }
  }
);

const getCompanyJobsSlice = createSlice({
  name: "getCompanyJobs",
  initialState: {
    loading: false,
    jobList: null as any,
    error: false,
    errorData: null as any,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCompanyJobs.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCompanyJobs.fulfilled, (state, action) => {
      state.loading = false;
      state.jobList = action.payload;
    });
    builder.addCase(getCompanyJobs.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorData = action.error;
    });
  },
});

export default getCompanyJobsSlice.reducer;
